import { SelectChangeEvent } from '@mui/material/Select';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { InviteNew } from '../../../creators/DataIntegration.creators';
import * as Integration from '../../../data-integration/types';
import * as Types from '../../../types';
import { SelectMenuItem } from '../../atomsLegacy/SelectDropdown/SelectDropdown';
import HeaderText from '../../atomsLegacy/typography/HeaderText';
import {
  DataIntegrationContainer,
  DataIntegrationDescription,
  StyledSelectDropdown as SelectDropdown,
} from './DataIntegration.styles';
import SCIMSetup from './SCIM/SCIMSetup';

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const DataIntegration = (props: Props) => {
  const isSAMLLogin =
    props.authenticationAdmin?.organisation &&
    Types.isSAMLAuth(
      props.authenticationAdmin?.organisation?.authenticationType,
    );
  const [option, setOption] = React.useState(
    props.authenticationAdmin?.scimProvider?.provider &&
      props.authenticationAdmin?.scimProvider?.active &&
      isSAMLLogin
      ? (props.authenticationAdmin?.scimProvider?.provider as Integration.Types)
      : props.dataIntegration,
  );

  const changeIntegration = (event: SelectChangeEvent<unknown>) =>
    setOption(event.target.value as Integration.Types);

  return (
    <React.Fragment>
      <DataIntegrationContainer data-testid={'data-integration-container'}>
        <HeaderText label="Data integration" weight="regular" />
        <DataIntegrationDescription>
          On this page you can set up synchronizing user data from your identity
          management or HR platform into vault.
        </DataIntegrationDescription>
        <SelectDropdown
          data-testid={'data-integration-dropdown'}
          disabled={props.authenticationAdmin?.scimProvider?.active}
          onChange={changeIntegration}
          value={option}
        >
          <SelectMenuItem value={'none'} key={'Select'}>
            Select Method
          </SelectMenuItem>
          {props.authenticationAdmin?.organisation?.authenticationType &&
          isSAMLLogin
            ? [
                Object.entries(Integration.Types)[
                  Object.keys(Integration.Types).indexOf(
                    props.authenticationAdmin?.organisation
                      .authenticationType as unknown as Integration.Types,
                  )
                ],
              ].map(([key, value]) => {
                if (value === 'none') return null;
                else
                  return (
                    <SelectMenuItem value={key} key={key}>
                      {value}
                    </SelectMenuItem>
                  );
              })
            : null}
        </SelectDropdown>

        {![Integration.Types.NONE].includes(props.dataIntegration) ||
        ![Integration.Types.NONE].includes(option) ? (
          <SCIMSetup provider={option} />
        ) : null}
      </DataIntegrationContainer>
    </React.Fragment>
  );
};

const mapStateToProps = ({ integrationStatus, organisation }: Types.State) => ({
  ...integrationStatus,
  authenticationAdmin: organisation.authenticationAdmin,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ InviteNew }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DataIntegration);
